import React from 'react'

function Produits() {
    return (
        <div>Produits</div>
    )
}

export default Produits